app.service('productPreviewWarranty', function(modal, pageConfig) {
	let $modal;

	let productId;
	let selectedWarrantyId;
	let selectedWarrantyPaymentType;
	let isToCartView;

	function selectActiveWarranty() {
		const $selectedWarranty = $('.js-add-warranty:checked');

		const warrantyId = $selectedWarranty.val();

		const warrantyPaymentType = $selectedWarranty.data('warranty-payment-type');

		$modal
			.find('.js-add-warranty')
			.filter(`[data-warranty-payment-type=${warrantyPaymentType}]`)
			.filter(`[value=${warrantyId}]`)
			.prop('checked', true);
	}

	function showSelectedWarrantyPaymentType() {
		const $modalWarrantyList = $modal.find('.warranty-item');
		const $selectedWarranty = $modalWarrantyList.filter(
			`[data-warranty-payment-type=${selectedWarrantyPaymentType}]`
		);

		$selectedWarranty.addClass('is-visible').removeClass('is-hidden');

		$modalWarrantyList
			.not($selectedWarranty)
			.addClass('is-hidden')
			.removeClass('is-visible');
	}

	function generateModal(content) {
		return modal.generate({
			content,
			id: 'services-dialog'
		});
	}

	function getModal() {
		return $.ajax({
			url: '/warranty-front-view.ltr',
			data: {
				warrantyId: selectedWarrantyId,
				productId: productId || pageConfig.getData('productCard').id
			}
		})
			.then(generateModal)
			.fail(() => modal.alert('Bład pobierania modala.'));
	}

	function setEvents() {}

	function setData(data) {
		selectedWarrantyPaymentType = data.warrantyPaymentType;

		selectedWarrantyId = data.warrantyId;

		productId = data.productId;

		isToCartView = data.isToCartView;
	}

	function initModal(modalHandler) {
		$modal = modalHandler.$modal;

		if (isToCartView) {
			$modal.find('.add-warranty-with-product').remove();
		}

		setEvents();

		showSelectedWarrantyPaymentType();

		selectActiveWarranty();
	}

	function init(data) {
		setData(data);

		getModal().then(initModal);
	}

	return {
		init
	};
});
